/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminCreateGroupSale,
    AdminCreateGroupSaleFromJSON,
    AdminCreateGroupSaleToJSON,
    AdminGroupSaleDetail,
    AdminGroupSaleDetailFromJSON,
    AdminGroupSaleDetailToJSON,
    AdminGroupSaleListResponse,
    AdminGroupSaleListResponseFromJSON,
    AdminGroupSaleListResponseToJSON,
    AdminUpdateGroupSale,
    AdminUpdateGroupSaleFromJSON,
    AdminUpdateGroupSaleToJSON,
} from '../models';

import {
    GroupSaleApi,
    GroupSaleApiAdminGroupSaleCreateRequest,
    GroupSaleApiAdminGroupSaleDetailRequest,
    GroupSaleApiAdminGroupSaleUpdateRequest,
} from './GroupSaleApi';

type AdminGroupSaleCreateQueryOptions = UseQueryOptions<
    string,
    Array<Error>,
    string,
    ['adminGroupSaleCreate', GroupSaleApiAdminGroupSaleCreateRequest]
>;

let useAdminGroupSaleCreateQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: GroupSaleApiAdminGroupSaleCreateRequest,
          options?: AdminGroupSaleCreateQueryOptions
      ) => AdminGroupSaleCreateQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleCreateQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: GroupSaleApiAdminGroupSaleCreateRequest,
        options?: AdminGroupSaleCreateQueryOptions
    ) => AdminGroupSaleCreateQueryOptions | undefined
) {
    useAdminGroupSaleCreateQueryGlobalOptions = callback;
}

export function getAdminGroupSaleCreateQueryKey(
    params: GroupSaleApiAdminGroupSaleCreateRequest
): ['adminGroupSaleCreate', GroupSaleApiAdminGroupSaleCreateRequest] {
    return ['adminGroupSaleCreate', params];
}

export function useAdminGroupSaleCreateQuery(
    params: GroupSaleApiAdminGroupSaleCreateRequest,
    options?: AdminGroupSaleCreateQueryOptions
): UseQueryResult<string, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminGroupSaleCreateQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleCreate(params, {signal})),
        {
            ...options,
            ...useAdminGroupSaleCreateQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminGroupSaleCreateMutationOptions = UseMutationOptions<
    string,
    Array<Error>,
    GroupSaleApiAdminGroupSaleCreateRequest
>;

let useAdminGroupSaleCreateMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGroupSaleCreateMutationOptions
      ) => AdminGroupSaleCreateMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleCreateMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGroupSaleCreateMutationOptions
    ) => AdminGroupSaleCreateMutationOptions | undefined
) {
    useAdminGroupSaleCreateMutationGlobalOptions = callback;
}

export function useAdminGroupSaleCreateMutation(
    options?: AdminGroupSaleCreateMutationOptions
): UseMutationResult<string, Array<runtime.ApiError>, GroupSaleApiAdminGroupSaleCreateRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleCreate(params)),
        {
            ...options,
            ...useAdminGroupSaleCreateMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminGroupSaleCreateInfiniteQueryKey(
    params: GroupSaleApiAdminGroupSaleCreateRequest
): ['adminGroupSaleCreate-infinite', GroupSaleApiAdminGroupSaleCreateRequest] {
    return ['adminGroupSaleCreate-infinite', params];
}

export function useAdminGroupSaleCreateInfiniteQuery(
    params: GroupSaleApiAdminGroupSaleCreateRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            string,
            Array<runtime.ApiError>,
            string,
            string,
            ['adminGroupSaleCreate-infinite', GroupSaleApiAdminGroupSaleCreateRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<string, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminGroupSaleCreateInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new GroupSaleApi().adminGroupSaleCreate({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminGroupSaleDetailQueryOptions = UseQueryOptions<
    AdminGroupSaleDetail,
    Array<Error>,
    AdminGroupSaleDetail,
    ['adminGroupSaleDetail', GroupSaleApiAdminGroupSaleDetailRequest]
>;

let useAdminGroupSaleDetailQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: GroupSaleApiAdminGroupSaleDetailRequest,
          options?: AdminGroupSaleDetailQueryOptions
      ) => AdminGroupSaleDetailQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleDetailQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: GroupSaleApiAdminGroupSaleDetailRequest,
        options?: AdminGroupSaleDetailQueryOptions
    ) => AdminGroupSaleDetailQueryOptions | undefined
) {
    useAdminGroupSaleDetailQueryGlobalOptions = callback;
}

export function getAdminGroupSaleDetailQueryKey(
    params: GroupSaleApiAdminGroupSaleDetailRequest
): ['adminGroupSaleDetail', GroupSaleApiAdminGroupSaleDetailRequest] {
    return ['adminGroupSaleDetail', params];
}

export function useAdminGroupSaleDetailQuery(
    params: GroupSaleApiAdminGroupSaleDetailRequest,
    options?: AdminGroupSaleDetailQueryOptions
): UseQueryResult<AdminGroupSaleDetail, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminGroupSaleDetailQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleDetail(params, {signal})),
        {
            ...options,
            ...useAdminGroupSaleDetailQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminGroupSaleDetailMutationOptions = UseMutationOptions<
    AdminGroupSaleDetail,
    Array<Error>,
    GroupSaleApiAdminGroupSaleDetailRequest
>;

let useAdminGroupSaleDetailMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGroupSaleDetailMutationOptions
      ) => AdminGroupSaleDetailMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleDetailMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGroupSaleDetailMutationOptions
    ) => AdminGroupSaleDetailMutationOptions | undefined
) {
    useAdminGroupSaleDetailMutationGlobalOptions = callback;
}

export function useAdminGroupSaleDetailMutation(
    options?: AdminGroupSaleDetailMutationOptions
): UseMutationResult<AdminGroupSaleDetail, Array<runtime.ApiError>, GroupSaleApiAdminGroupSaleDetailRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleDetail(params)),
        {
            ...options,
            ...useAdminGroupSaleDetailMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminGroupSaleDetailInfiniteQueryKey(
    params: GroupSaleApiAdminGroupSaleDetailRequest
): ['adminGroupSaleDetail-infinite', GroupSaleApiAdminGroupSaleDetailRequest] {
    return ['adminGroupSaleDetail-infinite', params];
}

export function useAdminGroupSaleDetailInfiniteQuery(
    params: GroupSaleApiAdminGroupSaleDetailRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminGroupSaleDetail,
            Array<runtime.ApiError>,
            AdminGroupSaleDetail,
            AdminGroupSaleDetail,
            ['adminGroupSaleDetail-infinite', GroupSaleApiAdminGroupSaleDetailRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminGroupSaleDetail, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminGroupSaleDetailInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new GroupSaleApi().adminGroupSaleDetail({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminGroupSaleListQueryOptions = UseQueryOptions<
    AdminGroupSaleListResponse,
    Array<Error>,
    AdminGroupSaleListResponse,
    ['adminGroupSaleList']
>;

let useAdminGroupSaleListQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGroupSaleListQueryOptions
      ) => AdminGroupSaleListQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleListQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGroupSaleListQueryOptions
    ) => AdminGroupSaleListQueryOptions | undefined
) {
    useAdminGroupSaleListQueryGlobalOptions = callback;
}

export function getAdminGroupSaleListQueryKey(): ['adminGroupSaleList'] {
    return ['adminGroupSaleList'];
}

export function useAdminGroupSaleListQuery(
    options?: AdminGroupSaleListQueryOptions
): UseQueryResult<AdminGroupSaleListResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminGroupSaleListQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleList({signal})),
        {
            ...options,
            ...useAdminGroupSaleListQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminGroupSaleListMutationOptions = UseMutationOptions<AdminGroupSaleListResponse, Array<Error>>;

let useAdminGroupSaleListMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGroupSaleListMutationOptions
      ) => AdminGroupSaleListMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleListMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGroupSaleListMutationOptions
    ) => AdminGroupSaleListMutationOptions | undefined
) {
    useAdminGroupSaleListMutationGlobalOptions = callback;
}

export function useAdminGroupSaleListMutation(
    options?: AdminGroupSaleListMutationOptions
): UseMutationResult<AdminGroupSaleListResponse, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleList()),
        {
            ...options,
            ...useAdminGroupSaleListMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminGroupSaleListInfiniteQueryKey(): ['adminGroupSaleList-infinite'] {
    return ['adminGroupSaleList-infinite'];
}

export function useAdminGroupSaleListInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminGroupSaleListResponse,
            Array<runtime.ApiError>,
            AdminGroupSaleListResponse,
            AdminGroupSaleListResponse,
            ['adminGroupSaleList-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminGroupSaleListResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminGroupSaleListInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleList()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminGroupSaleUpdateQueryOptions = UseQueryOptions<
    void,
    Array<Error>,
    void,
    ['adminGroupSaleUpdate', GroupSaleApiAdminGroupSaleUpdateRequest]
>;

let useAdminGroupSaleUpdateQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: GroupSaleApiAdminGroupSaleUpdateRequest,
          options?: AdminGroupSaleUpdateQueryOptions
      ) => AdminGroupSaleUpdateQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleUpdateQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: GroupSaleApiAdminGroupSaleUpdateRequest,
        options?: AdminGroupSaleUpdateQueryOptions
    ) => AdminGroupSaleUpdateQueryOptions | undefined
) {
    useAdminGroupSaleUpdateQueryGlobalOptions = callback;
}

export function getAdminGroupSaleUpdateQueryKey(
    params: GroupSaleApiAdminGroupSaleUpdateRequest
): ['adminGroupSaleUpdate', GroupSaleApiAdminGroupSaleUpdateRequest] {
    return ['adminGroupSaleUpdate', params];
}

export function useAdminGroupSaleUpdateQuery(
    params: GroupSaleApiAdminGroupSaleUpdateRequest,
    options?: AdminGroupSaleUpdateQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminGroupSaleUpdateQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleUpdate(params, {signal})),
        {
            ...options,
            ...useAdminGroupSaleUpdateQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminGroupSaleUpdateMutationOptions = UseMutationOptions<
    void,
    Array<Error>,
    GroupSaleApiAdminGroupSaleUpdateRequest
>;

let useAdminGroupSaleUpdateMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGroupSaleUpdateMutationOptions
      ) => AdminGroupSaleUpdateMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGroupSaleUpdateMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGroupSaleUpdateMutationOptions
    ) => AdminGroupSaleUpdateMutationOptions | undefined
) {
    useAdminGroupSaleUpdateMutationGlobalOptions = callback;
}

export function useAdminGroupSaleUpdateMutation(
    options?: AdminGroupSaleUpdateMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, GroupSaleApiAdminGroupSaleUpdateRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new GroupSaleApi().adminGroupSaleUpdate(params)),
        {
            ...options,
            ...useAdminGroupSaleUpdateMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminGroupSaleUpdateInfiniteQueryKey(
    params: GroupSaleApiAdminGroupSaleUpdateRequest
): ['adminGroupSaleUpdate-infinite', GroupSaleApiAdminGroupSaleUpdateRequest] {
    return ['adminGroupSaleUpdate-infinite', params];
}

export function useAdminGroupSaleUpdateInfiniteQuery(
    params: GroupSaleApiAdminGroupSaleUpdateRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            void,
            Array<runtime.ApiError>,
            void,
            void,
            ['adminGroupSaleUpdate-infinite', GroupSaleApiAdminGroupSaleUpdateRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminGroupSaleUpdateInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new GroupSaleApi().adminGroupSaleUpdate({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
